import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { setLoader } from "../store/slice/dashboard";

export const useErrorHandler = (errors) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // Build a stable key from actual error statuses so the effect only
    // fires when an error value genuinely changes, not on every render
    // (passing an inline array literal as a dep would re-fire every render).
    const errorsKey = Array.isArray(errors)
        ? errors.map((e) => e?.status ?? e?.originalStatus ?? null).join(",")
        : "";

    useEffect(() => {
        if (!Array.isArray(errors)) return;

        let hasError = false;

        for (let i = 0; i < errors.length; i++) {
            const err = errors[i];
            if (!err) continue;

            hasError = true;
            const status = err?.status || err?.originalStatus;
            const message = err?.data?.message;
            const errorObj = err?.data?.errors;

            // 🔐 Unauthorized
            if (
                status === 401 ||
                message === "Your account has been deactivated."
            ) {
                if (!localStorage.getItem("user_token")) {
                    localStorage.removeItem("user_token");
                    setTimeout(() => navigate("/login"), 500);
                }
                return;
            }

            // ⚠️ Validation errors (object or array)
            if (errorObj && typeof errorObj === "object") {
                const keys = Object.keys(errorObj);

                if (keys.length > 0 && errorObj[keys[0]]?.length > 0) {
                    toast.error(errorObj[keys[0]][0], {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 8000,
                    });
                    break;
                }
            }

            // 🚫 Other errors
            if (message === "Access denied" || message === "Project not found") {
                navigate("/project-list");
            }

            if (message) {
                toast.error(message, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 8000,
                });
            }

            break;
        }

        // Only dismiss the loader when an actual error was processed
        if (hasError) {
            dispatch(setLoader(false));
        }
    }, [errorsKey]);

    return [];
};
